"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _withThemeProps = _interopRequireDefault(require("../withThemeProps"));

var themeSettings = {
  name: 'SxListEmptyLabel'
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(2)
    },
    content: {
      padding: theme.spacing(1),
      color: theme.palette.text.hint
    }
  };
}, themeSettings);

var ListEmptyLabel = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className"]);
  var t = (0, _useTranslate.default)();
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    ref: ref,
    className: (0, _clsx.default)(classes.root, className)
  }, rest), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.content,
    align: "center",
    component: "div",
    noWrap: true,
    variant: "button"
  }, children || t('components/paginationList/emptyMessage')));
});

process.env.NODE_ENV !== "production" ? ListEmptyLabel.propTypes = {
  children: _propTypes.default.node
} : void 0;
ListEmptyLabel.displayName = 'ListEmptyLabel';

var _default = (0, _withThemeProps.default)(themeSettings)(ListEmptyLabel);

exports.default = _default;